import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const SESSION_KEY = "esg_track_session";

/** Random 16-byte session id, persisted for the browser tab lifetime. */
function getSessionId() {
  let sid = sessionStorage.getItem(SESSION_KEY);
  if (!sid) {
    const bytes = new Uint8Array(16);
    (window.crypto || window.msCrypto).getRandomValues(bytes);
    sid = Array.from(bytes, b => b.toString(16).padStart(2, "0")).join("");
    sessionStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
}

/** Paths that must NEVER be tracked (already-authenticated user data). */
const IGNORE_PREFIXES = ["/dashboard", "/admin", "/report", "/billing"];

function shouldTrack(pathname) {
  return !IGNORE_PREFIXES.some(p => pathname.startsWith(p));
}

/**
 * Fires a fire-and-forget POST /api/track/visit on every route change.
 * Silently swallows all errors, analytics must NEVER break the site.
 */
export default function useVisitTracker() {
  const location = useLocation();

  useEffect(() => {
    if (!BACKEND) return;
    if (!shouldTrack(location.pathname)) return;

    const payload = {
      path: location.pathname,
      referrer: document.referrer || "",
      session_id: getSessionId(),
      user_agent: navigator.userAgent || "",
    };

    // Use sendBeacon-style POST that survives page unload; fall back to axios.
    const url = `${BACKEND}/api/track/visit`;
    try {
      if (navigator.sendBeacon) {
        const blob = new Blob([JSON.stringify(payload)], {
          type: "application/json",
        });
        navigator.sendBeacon(url, blob);
      } else {
        axios.post(url, payload).catch(() => {});
      }
    } catch (_e) {
      // never surface analytics errors
    }
  }, [location.pathname]);
}
